/* eslint-disable indent */
/* eslint-disable no-unused-vars */
/* eslint-disable no-constant-condition */
/* eslint-disable react/react-in-jsx-scope */
// /* eslint-disable no-unused-vars */
// import React from "react";
import Heading from "../../../components/Heading";
import {
  Row,
  Col,
  Table,
  Tag,
  Card,
  Typography,
  Spin,
  message,
  Tooltip,
} from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { ReactComponent as Driver } from "../../../assests/images/LCRIcons/Driver.svg";
import { ReactComponent as Calendar } from "../../../assests/images/LCRIcons/calendar_month.svg";
import { ReactComponent as Road } from "../../../assests/images/LCRIcons/road.svg";
import { ReactComponent as Truck } from "../../../assests/images/LCRIcons/Truck.svg";
import { ReactComponent as FrontLoader } from "../../../assests/images/LCRIcons/Frontloader.svg";
import { ReactComponent as Loaction } from "../../../assests/images/LCRIcons/location_on-1.svg";
import { ReactComponent as Bag } from "../../../assests/images/LCRIcons/money_bag.svg";
import { ReactComponent as Packet } from "../../../assests/images/LCRIcons/package_2.svg";
import { ReactComponent as Bagg } from "../../../assests/images/LCRIcons/Recyclebag.svg";
import { ReactComponent as Event } from "../../../assests/images/LCRIcons/event_available.svg";
import { ReactComponent as CheckMark } from "../../../assests/images/LCRIcons/tickMark.svg";
import Smcs_Loader from "../../../assests/images/loader-new.gif";
import { ReloadOutlined } from "@ant-design/icons";

import nodeAPI from "../../../api/nodeUrls";
import React, { useState } from "react";
import "./style.scss";
import { Collapse } from "antd";
import moment from "moment";
import {
  camelCase,
  capitaliseWithHyphen,
  normalizeString,
  showErrorMessage,
} from "../../../utils";
import API from "../../../api";
import { useEffect } from "react";

function LCRReportNew() {
  const { Panel } = Collapse;
  const history = useLocation();
  const navigate = useNavigate();
  const {
    LCRTableDetails,
    LCR_BAG_SHIPEMNT_DETAILS,
    NEW_LCR_REPORT,
    NEW_LCR_REPORT_TRACKING,
  } = nodeAPI;
  const [loading, setLoading] = useState(false);
  const [bagAndShipmentdata, setBagAndShipmentdata] = useState([]);
  const [activeKeys, setActiveKeys] = useState([]);
  const [panelContent, setPanelContent] = useState({});
  const [loadingPanels, setLoadingPanels] = useState({});
  // Set initial report from sessionStorage if available
  const [report, setReport] = useState(() => {
    const recordStr = sessionStorage.getItem("LCR_REPORT_RECORD");
    if (recordStr) {
      try {
        return JSON.parse(recordStr);
      } catch (e) {
        console.log(e);
      }
    }
    return {};
  });
  const { Title, Text } = Typography;

  const colorObj = {
    INITIATED: "#007BFF", // Bright Blue
    STARTED: "#17A2B8", // Teal
    "IN-TRANSIT": "#FFC107", // Amber/Yellow
    COMPLETED: "#28A745", // Green
    PENDING: "#007BFF", // 
    LOCKED: "#007BFF", // 
    UNLOCKED: "#FFC107", // 
  };
  useEffect(() => {
    getLCRDetailData();
    getLCRTableData(history?.state?.vehicle_lcr_id);
  }, [history?.state?.vehicle_lcr_id]);

  const EllipsisMiddle = ({ suffixCount, children }) => {
    const { Text } = Typography;
    const start = children?.slice(0, children.length - suffixCount).trim();
    return (
      <Text
        style={{
          maxWidth: "100%",
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        <Tooltip placement="topLeft" title={children}>
          {start}...
        </Tooltip>
      </Text>
    );
  };
  function checkBagReceived(report, bagOutKey, bagInKey) {
    let bagReceived = "";

    if (+report[bagOutKey] === +report[bagInKey]) {
      if (report[bagOutKey] == 0 && report[bagInKey] == 0) {
        bagReceived = "";
      } else {
        bagReceived = true;
      }
    } else {
      bagReceived = false;
    }

    return bagReceived;
  }

  const fetchPanelData = async (openedPanel, perentIndex) => {
    const filterData = bagAndShipmentdata[perentIndex].lcr_details.find(
      (item) => item.awb_number == openedPanel
    );
    setLoadingPanels((prev) => ({ ...prev, [openedPanel]: true }));
    const apiURL = filterData.bag
      ? `${filterData?.awb_number}&isBag=true`
      : filterData?.awb_number;
    const response = await API.Api(
      LCR_BAG_SHIPEMNT_DETAILS + apiURL
    ).NodeGetWithPremise();
    console.log("BagDetails:", JSON.stringify(bagAndShipmentdata, null, 2));
    if (response.status) {
     
      return response.response.data;
    } else {
      setLoading(false);
      showErrorMessage(response.response.data.message || "Something went wrong");
    }
  };

  const columns = [
    {
      title: "Shipment No.",
      dataIndex: "barcode_no",
      key: "barcode_no",
      width: 150,
      render: (text, record) => (
        <span
        style={{ color: "#2977ff", cursor: "pointer", textDecoration: "underline" }}
        onClick={() => {
          const awb=record?.barcode_no || record?.awb_number;
          const url = `/shipment-tracker?awb=${awb}`;
          window.open(url, "_blank");
        }}
    >
        {record?.barcode_no || record?.awb_number}
    </span>
      ),
    },
    {
      title: "Destination Hub Name",
      dataIndex: "destination_hub",
      key: "destination_hub",
      width: 180,
      render: (text) => <div>{capitaliseWithHyphen(text)}</div>,
    },
    {
      title: "Travel Status",
      dataIndex: "booking_status",
      key: "booking_status",
      width: 120,
      render: (text, record) => (
        <div>
          <Tag
            color={"#C5F3D9"}
            style={{
              marginLeft: 8,
              borderRadius: "10px",
              color: "#475467",
              width: "150px",
              textAlign: "center",
              whiteSpace: "normal",
            }}
          >
            {normalizeString(text)}
          </Tag>
          {capitaliseWithHyphen(record?.current_destination)}
        </div>
      ),
    },
    {
      title: "Date & Time",
      key: "latest_operation_time",
      dataIndex: "latest_operation_time",
      width: 150,
      render: (text) => (
        <div>{moment?.utc(text)?.format("DD-MM-YYYY hh:mm A")}</div>
      ),
    },
  ];

  const getLCRDetailData = async () => {
    setLoading(true);

    // Try to get vehicle_lcr_id from history.state or sessionStorage
    let vehicle_lcr_id = history?.state?.vehicle_lcr_id;
    if (!vehicle_lcr_id) {
      const recordStr = sessionStorage.getItem("LCR_REPORT_RECORD");
      if (recordStr) {
        try {
          const record = JSON.parse(recordStr);
          vehicle_lcr_id = record.vehicle_lcr_id;
        } catch (e) {
          // Intentionally left empty: ignore JSON parse errors
        }
      }
    }

    if (!vehicle_lcr_id) {
      showErrorMessage("LCR ID not found. Please try again from the LCR list.");
      setLoading(false);
      return;
    }

    const response = await API.Api(
      LCRTableDetails + vehicle_lcr_id
    ).NodeGetWithPremise();
    //console.log(" ReportTabee"+ LCRTableDetails + vehicle_lcr_id);
    
    if (response.status) {
      console.log("setBagAndShipmentdataResponce:", JSON.stringify(response, null, 2));
      console.log(" setBagAndShipmentdata"+ LCRTableDetails + vehicle_lcr_id);
      setBagAndShipmentdata(response?.response?.data);
      setLoading(false);
    } else {
      window.history.back();
      showErrorMessage(response?.response?.data?.message || "Network Error");
      setLoading(false);
    }
  };

  const onChange = async (keys, perentIndex) => {
    setActiveKeys(keys);

    const openedPanel = keys.find((key) => !activeKeys.includes(key));

    if (openedPanel && !panelContent[openedPanel]) {
      const data = await fetchPanelData(openedPanel, perentIndex);
      setPanelContent((prev) => ({ ...prev, [openedPanel]: data }));
      setLoadingPanels((prev) => ({ ...prev, [openedPanel]: false }));
    }
  };

  const isBagOrShipment = (isbag) => {
    return (
      <>
        {isbag.bag ? (
          <>
            <span>
              <Bagg /> Bag No.-
              <span className="vehicleContainerValue"
              style={{ color: "#2977ff", cursor: "pointer", textDecoration: "underline" }}
              onClick={() => {
                const url = `/shipment-tracker?awb=${isbag?.awb_number}`;
                window.open(url, "_blank");
              }}
              >{isbag?.awb_number}</span>
            </span>
            <span> {`(${isbag?.shipment_out_count} Shipments)`}</span>
          </>
        ) : (
          <span className="align-center">
            <Packet /> Ind. Shipment-
              <span className="vehicleContainerValue"
                style={{ color: "#2977ff", cursor: "pointer", textDecoration: "underline" }}
                onClick={() => {
                  const url = `/shipment-tracker?awb=${isbag?.awb_number}`;
                  window.open(url, "_blank");
                }}
              >{isbag.awb_number}</span>
          </span>
        )}
        {isbag?.premise_name &&
          activeKeys.includes(isbag?.awb_number.toString()) && (
            <Row className="pt-05">
              <Col lg={6}>
                <span className="vehicleContainerLabel"> Destination Hub:</span>
                <span className="vehicleContainerValue">
                  {normalizeString(isbag?.premise_name)}
                </span>
              </Col>
              <Col lg={6}>
                <span className="vehicleContainerLabel">Status:</span>
                <span className="vehicleContainerValue">
                  {
                    <Tag
                      color={"#C5F3D9"}
                      style={{
                        marginLeft: 8,
                        borderRadius: "10px",
                        color: "#475467",
                        width: "150px",
                        textAlign: "center",
                        whiteSpace: "normal",
                      }}
                    >
                      {normalizeString(isbag?.status)}
                    </Tag>
                  }
                </span>
              </Col>
              <Col lg={6}>
                <span className="vehicleContainerLabel">Date & Time: </span>
                <span className="vehicleContainerValue">
                  {moment
                    .utc(isbag?.latest_operation_time)
                    .format("DD-MM-YYYY hh:mm A")}
                </span>
              </Col>
              <Col lg={6}></Col>
            </Row>
          )}
      </>
    );
  };

  const getLCRTableData = async (searchValue) => {
    setLoading(true);
    // Always get vehicle_lcr_id from history.state or sessionStorage
    let vehicle_lcr_id = searchValue;
    if (!vehicle_lcr_id) {
      vehicle_lcr_id = history?.state?.vehicle_lcr_id;
      if (!vehicle_lcr_id) {
        const recordStr = sessionStorage.getItem("LCR_REPORT_RECORD");
        if (recordStr) {
          try {
            const record = JSON.parse(recordStr);
            vehicle_lcr_id = record.vehicle_lcr_id;
          } catch (e) {
            console.log(e);
          }
        }
      }
    }
   // console.log("LCR ID used for API:", vehicle_lcr_id);
    if (!vehicle_lcr_id) {
      showErrorMessage("LCR ID not found. Please try again from the LCR list.");
      setLoading(false);
      return;
    }
    const response = await API.Api(
      history?.state?.tracking
        ? NEW_LCR_REPORT_TRACKING + vehicle_lcr_id
        : NEW_LCR_REPORT_TRACKING + "?search=" + vehicle_lcr_id
    ).NodeGetWithCustomHeader({ lcr_id: vehicle_lcr_id });
    //console.log("VecicleResponse:", JSON.stringify(response, null, 2));
    if (response.status && response?.response?.data?.data?.length > 0) {
      setLoading(false);
      setReport({ ...response?.response?.data?.data[0], key: "key" });
    } else {
      //showErrorMessage("No data found for this LCR ID");
      setLoading(false);
      // Do not clear the report state if API fails
      window.history.back();
    }
  };

  // Custom back handler like ShipmentTracker
  const goBackToPrevScreen = () => {
    if (window.history.length <= 1) {
      window.close();
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <div className="p-2-tab">
        {/* <Heading title={`LCR No. ${report?.lcr_num}`} /> */}
        <Spin spinning={loading}>
          <Heading title="LCR report" showBack={true} goBack={goBackToPrevScreen} />
          <Card
            style={{ borderRadius: 10, marginBottom: 20, marginTop: 20 }}
            bodyStyle={{ padding: 20 }}
          >
            <div className="space-between-start">
              <Row gutter={[16, 16]} justify="space-between">
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Title level={4} style={{ color: "#475467" }}>
                    Vehicle LCR NO.
                  </Title>
                  <Text strong>{report?.vehicle_lcr_id}</Text>
                  <Tag
                    color={colorObj[report?.status]}
                    style={{ marginLeft: 8, borderRadius: "10px" }}
                  >
                    {report?.status}
                  </Tag>
                </Col>
              </Row>
              <Text strong style={{textAlign: "right", paddingTop: "37px" }}>Trip Status:
                 <Tag
                    color={colorObj[report?.trip_status]}
                    style={{ marginLeft: 8, borderRadius: "10px" }}
                  >
                    {report?.trip_status}
                  </Tag>
                </Text>
              <Tooltip title={"Reload"}>
                <ReloadOutlined
                  // onClick={getCurrentTime}
                  onClick={() => getLCRTableData(report?.vehicle_lcr_id)}
                  style={{
                    fontSize: 18,
                    paddingLeft: "10px",
                    color: "black",
                  }}
                />
              </Tooltip>
            </div>
            <Row className="pt-1" gutter={[16, 16]}>
              <Col xs={24} sm={12} md={8} lg={8} className="align-center label-value-col">
                <Calendar />
                <span className="vehicleContainerLabel">Created at: </span>
                <span className="vehicleContainerValue truncated-text">
                  {moment.utc(report?.created_date).format("DD-MM-YYYY hh:mm A")}
                </span>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} className="align-center label-value-col">
                <Road />
                <span className="vehicleContainerLabel">Travel Mode: </span>
                <span className="vehicleContainerValue truncated-text">
                  {report?.travel_by}
                </span>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} className="align-center label-value-col">
                <Truck />
                <span className="vehicleContainerLabel">Vehicle/Flight No: </span>
                <span className="vehicleContainerValue truncated-text">
                  {report?.vehicle_num}
                </span>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} className="align-center label-value-col">
                <FrontLoader />
                <span className="vehicleContainerLabel">Co-Loader: </span>
                <span className="vehicleContainerValue truncated-text">
                  {report?.coloader}
                </span>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} className="align-center label-value-col">
                <Driver />
                <span className="vehicleContainerLabel">Driver Name: </span>
                <span className="vehicleContainerValue truncated-text">
                  {report?.driver_name}
                </span>
              </Col>
              <Col xs={24} sm={12} md={8} lg={8} className="align-center label-value-col">
                <Loaction />
                <span className="vehicleContainerLabel">Destination Hub: </span>
                <span className="vehicleContainerValue truncated-text">
                  {camelCase(report?.destination_hub)}
                </span>
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} className="align-center label-value-col">
                <Bag />
                <span className="vehicleContainerLabel">Bag Out | In: </span>
                <span className="vehicleContainerValue truncated-text">
                  {`${report?.bag_out_count} | ${report?.bag_in_count}`}
                </span>
                {checkBagReceived(report, "bag_out_count", "bag_in_count") === false && (
                  <Tag
                    color={checkBagReceived(report, "bag_out_count", "bag_in_count") ? "#C5F3D9" : "red"}
                    style={{ marginLeft: 8, borderRadius: "10px", color: "#475467" }}
                  >
                    Pending
                  </Tag>
                )}
                { checkBagReceived(report, "bag_out_count", "bag_in_count") === true && (
                  <Tag
                    color={checkBagReceived(report, "bag_out_count", "bag_in_count") ? "#C5F3D9" : "red"}
                    style={{ marginLeft: 8, borderRadius: "10px", color: "#475467" }}
                  >
                    Received
                  </Tag>
                )}
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} className="align-center label-value-col">
                <Packet />
                <span className="vehicleContainerLabel">Bagged Shipment Out | In: </span>
                <span className="vehicleContainerValue truncated-text">
                  {`${report?.in_bag_shipment_out_count} | ${report?.in_bag_shipment_in_count}`}
                </span>
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} className="align-center label-value-col">
                <Packet />
                <span className="vehicleContainerLabel">Individual Shipment Out | In: </span>
                <span className="vehicleContainerValue truncated-text">
                  {`${report?.shipment_out_count} | ${report?.shipment_in_count}`}
                </span>
                {checkBagReceived(report, "shipment_out_count", "shipment_in_count") === false && (
                  <Tag
                    color={checkBagReceived(report, "shipment_out_count", "shipment_in_count") ? "#C5F3D9" : "red"}
                    style={{ marginLeft: 8, borderRadius: "10px", color: "#475467" }}
                  >
                    Pending
                  </Tag>
                )}
                {checkBagReceived(report, "shipment_out_count", "shipment_in_count") === true && (
                  <Tag
                    color={checkBagReceived(report, "shipment_out_count", "shipment_in_count") ? "#C5F3D9" : "red"}
                    style={{ marginLeft: 8, borderRadius: "10px", color: "#475467" }}
                  >
                    Received
                  </Tag>
                )}
              </Col>
              <Col xs={24} sm={24} md={24} lg={24} className="align-center label-value-col">
                <Loaction />
                <span className="vehicleContainerLabel">Route: </span>
                <span className="vehicleContainerValue truncated-text">
                  {report?.route_name}
                </span>
              </Col> 
            </Row>
          </Card>
        </Spin>
      </div>
      {bagAndShipmentdata?.map((payloadItem, perentIndex) => (
        <div className="container" key={perentIndex}>
          <div
            style={{
              backgroundColor: payloadItem.lcr_status
                ? "rgb(217 243 211)"
                : "#E5E5E5",
              borderRadius: "5px",
            }}
          >
            <div className="space-between">
              <div
                style={{
                  padding: " 20px",
                  fontSize: "15px",
                  fontWeight: "600",
                }}
              >
                <span className="vehicleContainerLabel"> STOP LCR: </span>
                <span className="vehicleContainerValue">
                  { payloadItem?.lcr_num}{payloadItem?.sev_lcr_id ? `(${payloadItem?.sev_lcr_id})`:""}
                  {/* {process.env.REACT_APP_ENV == "prod"
                    ? payloadItem?.sev_lcr_id
                    : payloadItem?.lcr_num} */}
                </span>
                &nbsp;|&nbsp;
                {/* <span className="vehicleContainerLabel">Destination Hub:</span> */}
                <span className="vehicleContainerValue">
                  {camelCase(payloadItem?.from_hub)} to{" "}
                  {camelCase(payloadItem?.to_hub)}
                </span>
                <span className="vehicleContainerLabel">
                  ( {+payloadItem?.bag_count} Bags
                  {+payloadItem?.shipment_count > 0 &&
                    ` & ${payloadItem?.shipment_count} Individual Shipment`}
                  )
                </span>
              </div>
              <div className="center pr-1">
                {payloadItem.lcr_status && <CheckMark />}
              </div>
            </div>
            <Collapse
              onChange={(e) => onChange(e, perentIndex)}
              activeKey={activeKeys}
            >
              {payloadItem.lcr_details.map((item) => (
                <Panel
                  header={<div>{isBagOrShipment(item)}</div>}
                  key={item?.awb_number?.toString()}
                >
                  <Table
                    dataSource={panelContent[item?.awb_number?.toString()]}
                    pagination={false}
                    columns={columns}
                    scroll={{ x: 1300 }}
                    loading={{
                      indicator: (
                        <img
                          src={Smcs_Loader}
                          style={{ height: "100px", width: "100px" }}
                        />
                      ),
                      spinning: loadingPanels[item?.awb_number?.toString()],
                    }}
                  />
                </Panel>
              ))}
            </Collapse>
          </div>
        </div>
      ))}
    </>
  );
}

export default LCRReportNew;
